// ListCell Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ProgressBar from '../../ui/common/common/progress_bar/progress_bar.jsx'
import Util from '../../ui/lib/util.jsx'

import DateUtil from '../../ui/lib/dateutil.jsx'
import IntlMessage from '../../ui/common/common/intl/intl_message.jsx'
import CellContainer from './CellContainer.jsx'

const colors = {
  text: '#333',
  link: '#4dbce9',
  linkHover: '#3474a1',
  status: {
    active: '#adc353',
    closed: 'rgba(31, 69, 101, 0.6)',
    completed: '#9ea4a4',
    estimate: '#1f4565',
    paid: '#7abd9a',
    draft: '#ccc9c6',
    overdue: '#ff6565',
    final: '#9ea4a4'
  }
}

const StatusCell = styled.div`
  font-size: 12.75px;
  text-transform: uppercase;
  padding-top: 3px;
  color: ${props => colors.status[props.status] || 'currentColor'};
`

StatusCell.propTypes = {
  status: PropTypes.string
}

const LinkCell = styled.div`
  color: ${colors.text};

  &:hover {
    color: ${colors.linkHover};
  }
`

class ListCell extends Component {
  static get propTypes () {
    return {
      type: PropTypes.string,
      value: PropTypes.any,
      defaultValue: PropTypes.string,
      width: PropTypes.string,
      formatProgressOverdue: PropTypes.bool,
      onClick: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      type: '',
      value: '',
      defaultValue: '-',
      width: '',
      formatProgressOverdue: false,
      onClick: null
    }
  }

  render () {
    return (
      <CellContainer width={this.props.width} className='list-cell'>
        {this.renderItems()}
      </CellContainer>
    )
  }

  /* Private Function */
  renderItems () {
    const { type, value, defaultValue, formatProgressOverdue, onClick } = this.props

    let fieldValue = ''
    if (value !== '') {
      switch (type) {
        case 'text':
          fieldValue = value
          break

        case 'progress':
          fieldValue = (
            <ProgressBar
              value={typeof value === 'number' ? Math.round(value) : 0}
              mode='determinate'
              formatOverdue={formatProgressOverdue}
              max={100}
              buffer={100}
              type='linear'
            />
          )
          break

        case 'date':
          fieldValue = value ? DateUtil.getDisplayDate(value) : defaultValue
          break

        case 'link':
          fieldValue = <LinkCell className='link'>{value}</LinkCell>
          break

        case 'time':
          fieldValue = DateUtil.getDisplayTime(value, defaultValue)
          break

        case 'status':
          fieldValue = (
            <StatusCell status={value.toLowerCase()}>
              <IntlMessage ident={Util.getTranslatedStatus(value)} />
            </StatusCell>
          )
          break

        case 'html':
          fieldValue = <div dangerouslySetInnerHTML={{ __html: value }} />
          break

        case 'minutestotime':
          fieldValue = Util.convertMinutesToHour(value)
          break

        case 'boolean':
          fieldValue = (
            <div
              dangerouslySetInnerHTML={{
                __html: value ? '<code>&#10004;</code>' : '<code>&#10008;</code>'
              }}
            />
          )
          break

        default:
          break
      }
    }

    return (
      <div className='listrowcell' onClick={onClick}>
        {fieldValue || defaultValue}
      </div>
    )
  }
}

export default ListCell
